import React from "react";
import { formatDate } from "../../../helpers/helpers.jsx";
import { text01, text02, text03, text04, postTitle } from "./Post05.json";
import image from "./qrcode.png";

const BlogPost = ({ lang }) => {
  return (
    <div className="postContainer">
      <div className="postHeader">
        <h1 className="postTitle">{postTitle[lang]}</h1>
        <span className="postedBy">{formatDate(lang, "2025-05-13")}</span>
      </div>
      <div className="postText postText-center">
        <div className="postImageContainer-50">
          <img src="images/P1012716.jpg" alt="Musica Pro Sancta Cecilia" />
        </div>
        <p style={{ textAlign: "center" }}>
          {text01[lang]} <br />
          <br /> {text02[lang]} <br />
          <br /> {text03[lang]} <br />
          <br /> {text04[lang]}
          <a href="https://www.youtube.com/live/d-KiP529gjE" target="_blank">https://www.youtube.com/live/d-KiP529gjE</a>
          <br />
        </p>
        <div className="postImageContainer-30">
          <img src={image} alt="QR Code" />
        </div>

      </div>
    </div>
  );
};

export default BlogPost;



// WEBPACK FOOTER //
// ./src/components/Home/post05/Post05.jsx